export default defineNuxtRouteMiddleware((to, from) => {
    //token 判断用户是否登录
    let fullPath = encodeURI(to.fullPath);
    const accessToken = useCookie('accessToken');
    if (!accessToken.value) {
        return navigateTo({path: '/login', query: { redirect: fullPath }})
    }
})
